// src/data/projects.js
//
// This module defines the list of projects showcased on the portfolio.
// Each entry describes one project, including its title, a short
// description, the type of media to display (image or video), the
// source file for that media, and optional links to live demos and
// source code repositories.  To add a new project, simply append
// another object to the exported array with the appropriate fields.

const projects = [
  {
    title: "RoboFriends",
    description:
      "A React app that fetches robot user data from JSONPlaceholder and lets you filter friends by name.",
    mediaType: "image",
    mediaSrc: "src/assets/project.png",
    liveLink: "https://JarelEze1.github.io/robofriends/",
    sourceLink: "https://github.com/JarelEze1/robofriends",
  },
  {
    title: "My Smart App",
    description:
      "A productivity and time‑tracking tool built with React Native. Features include task management, reminders and performance analytics.",
    mediaType: "video",
    mediaSrc: "src/assets/mysmartapp.mp4",
    liveLink: "#", // Replace with actual demo link when available
    sourceLink: "#", // Replace with repository link if open source
  },
  {
    title: "Landing Page Showcase",
    description:
      "A responsive landing page template demonstrating modern layouts, animations and CTA components.",
    mediaType: "video",
    mediaSrc: "src/assets/landingpage.mp4",
    liveLink: "#", // Replace with actual live site link
    sourceLink: "#", // Replace with repository link if available
  },
  {
    title: "3D Printer Preview",
    description:
      "A teaser video for a 3D printer product page, highlighting the design and key features.",
    mediaType: "video",
    mediaSrc: "src/assets/3dprinter.mp4",
    liveLink: "#", // Replace with product page when published
    sourceLink: "#",
  },
  {
    title: "Shorts Savory",
    description:
      "A dynamic promo for a short‑form video platform, created to illustrate micro‑interaction design and editing skills.",
    mediaType: "video",
    mediaSrc: "src/assets/shortssavory.mp4",
    liveLink: "#",
    sourceLink: "#",
  },
  {
    title: "Weight Tracker",
    description:
      "An intuitive web app that helps users track their weight over time, built with vanilla JavaScript and Chart.js.",
    mediaType: "image",
    mediaSrc: "src/assets/weighttracker.png",
    liveLink: "#",
    sourceLink: "#",
  },
];

export default projects;